import { INTERNAL } from '../config/internal'

export const checkInternal = () => {
	return document.cookie
		.split(';')
		.some(item => item.trim().startsWith(INTERNAL))
}
